<template>
  <alzata-dialog
    ref="modal"
    size="lg"
    :title="'Delete Vacination'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <span for="name" class="small">Do you want delete "{{name}}"?</span>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide();">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="deleteVaccination">
        Delete
      </button>
    </template>
  </alzata-dialog>
</template>

<script>

export default {
  name: "DeleteVaccinationDialog",
  emits: ["deleteVaccination"],
  components: {
  },
  mounted() {
    (async () => {
     
    })();
  },
  data() {
    return {
      vaccination: null,
      name: null,
    };
  },
  methods: {
    show(vaccination) {
      (async () => {
        this.vaccination = vaccination;
        this.name = vaccination.name;

        this.$refs.modal.show();
      })();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async deleteVaccination() {
      this.$emit("deleteVaccination", this.vaccination);
    },
  },
};
</script>
